<template>
  <v-card class="search-header-card pb-1" color="transparent" elevation="0" rounded="lg" width="100%">
    <!-- Filtros Principales -->
    <v-row align="center" justify="start" class="mb-2">
      <!-- UNIDAD DE NEGOCIOS -->
      <v-col cols="12" sm="6" md="auto" lg="auto" xl="auto" class="py-1 py-md-2 px-1">
        <v-autocomplete v-model="business_selected" :items="itemsBussines" label="Unidad de negocio" color="primary"
          item-color="primary" @change="handleBusinessChange" prepend-inner-icon="mdi-office-building-outline" outlined
          dense :hide-details="require_selection ? 'auto' : true" :rules="businessRules" class="filter-input">
          <template v-slot:prepend-inner>
            <v-icon color="primary" size="20">mdi-office-building-outline</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- LOCATION -->
      <v-col v-show="show_location" cols="12" sm="6" md="auto" lg="auto" xl="auto" class="py-1 py-md-2 px-1">
        <v-autocomplete v-model="location_selected" :items="itemsLocations2" @change="handleLocationChange"
          return-object color="primary" item-color="primary" label="Sucursal" outlined dense hide-details
          class="filter-input">
          <template v-slot:prepend-inner>
            <v-icon color="primary" size="20">mdi-map-marker-outline</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- RANGO -->
      <v-col v-show="show_weeks" cols="12" sm="6" md="auto" lg="auto" xl="auto" class="py-1 py-md-2 px-1">
        <v-autocomplete v-model="rangeSelected" :items="rangeTime" label="Rango de tiempo" color="primary"
          item-color="primary" outlined dense hide-details @change="handleRangeChange" class="filter-input">
          <template v-slot:prepend-inner>
            <v-icon color="primary" size="20">mdi-calendar-range</v-icon>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- FECHAS PERSONALIZADAS -->
      <v-col v-show="rangeSelected == '7'" cols="12" md="6" lg="6" xl="auto" class="py-1 py-md-2 px-1" align="center"
        justify="center">
        <v-row no-gutters class="date-range-row">
          <v-col cols="12" sm="6" class="pr-0 pr-sm-2 mb-2 mb-sm-0">
            <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto" max-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="dateFormatDMY" label="Fecha desde" readonly v-bind="attrs" v-on="on" outlined
                  dense hide-details color="primary" class="filter-input">
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="20">mdi-calendar-start</v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="date" @input="menu = false" color="primary" header-color="primary" show-current
                locale="es"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" class="pl-0 pl-sm-2">
            <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto" max-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date2FormatDMY" label="Fecha hasta" readonly v-bind="attrs" v-on="on" outlined
                  dense hide-details color="primary" class="filter-input">
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="20">mdi-calendar-end</v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="date2" @input="menu2 = false" color="primary" header-color="primary" show-current
                locale="es"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>

      <!-- BOTÓN ACTUALIZAR -->
      <v-col v-if="show_refresh" cols="12" sm="6" md="3" lg="auto" xl="auto"
        class="py-1 py-md-2 px-1 d-flex align-center" align="center" justify="center">
        <v-btn color="primary" @click="updateData" :loading="loading" class="update-btn" rounded elevation="2"
          :block="$vuetify.breakpoint.xs">
          <v-icon left size="20">mdi-refresh</v-icon>
          <span class="font-weight-medium">Actualizar</span>
        </v-btn>
      </v-col>
    </v-row>

    <!-- FILTROS ADICIONALES -->
    <v-expand-transition>
      <div v-show="showAdditionalFilters">
        <v-divider class="my-4"></v-divider>
        <v-row class="mt-2">
          <v-col v-show="show_accounting" cols="12" sm="6" md="4" lg="3" class="py-1 py-md-2">
            <v-autocomplete v-model="filters.account" :items="accounts" label="Cuenta contable" color="primary"
              item-color="primary" outlined dense hide-details @change="updateData()">
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-book-open-page-variant</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col v-show="show_department" cols="12" sm="6" md="4" lg="3" class="py-1 py-md-2">
            <v-autocomplete v-model="department_selected" :items="itemsDepartment" label="Departamento" color="primary"
              item-color="primary" outlined dense hide-details @change="updateData()">
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-domain</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col v-show="show_diary_book_type" cols="12" sm="6" md="4" lg="3" class="py-1 py-md-2">
            <v-autocomplete v-model="filters.type_account" :items="type_accounts" label="Tipo libro" color="primary"
              item-color="primary" outlined dense hide-details item-text="description" item-value="id"
              @change="updateData()">
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-book-variant</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col v-show="show_accounts" cols="12" sm="6" md="4" lg="3" class="py-1 py-md-2">
            <v-autocomplete v-model="filters.accountBank" :items="bussinessAccount" label="Cuenta de banco"
              color="primary" item-color="primary" outlined dense :hide-details="require_selection ? 'auto' : true"
              :rules="accountBankRules" background-color="grey lighten-5"
              class="elevation-2 rounded-lg border border-primary" item-text="text" item-value="account_id"
              @change="updateData()">
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-bank</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col v-show="show_payments" cols="12" sm="6" md="4" lg="3" class="py-1 py-md-2">
            <v-autocomplete v-model="filters.payments_id" :items="payments" label="Método de pago" color="primary"
              item-color="primary" outlined dense hide-details item-text="name" item-value="id"
              class="elevation-2 rounded-lg border border-success" @change="updateData()">
              <template v-slot:prepend-inner>
                <v-icon color="success">mdi-cash</v-icon>
              </template>
              <template v-slot:selection="{ item }">
                <v-icon left>{{ getIconPayments(item.id) }}</v-icon>
                {{ item.name }}
              </template>
              <template v-slot:item="{ item }">
                <v-icon left>{{ getIconPayments(item.id) }}</v-icon>
                {{ item.name }}
              </template>
            </v-autocomplete>
          </v-col>

          <v-col v-show="show_category" cols="12" sm="6" md="4" lg="3" class="py-1 py-md-2">
            <v-autocomplete v-model="filters.category"
              :items="categories.filter((element) => element.parent_id === null)" label="Categoría" color="primary"
              item-color="primary" outlined dense hide-details item-text="name" item-value="id" @change="updateData()">
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-shape</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col v-show="show_category" cols="12" sm="6" md="4" lg="3" class="py-1 py-md-2">
            <v-autocomplete v-model="filters.sub_category" :items="categories.filter((element) => element.parent_id === filters.category)
              " label="Sub categoría" color="primary" item-color="primary" outlined dense hide-details item-text="name"
              item-value="id" @change="updateData()">
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-shape-outline</v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <!-- Botón para mostrar/ocultar filtros adicionales -->
    <v-row v-if="hasAdditionalFilters" no-gutters justify="center" class="mt-2">
      <v-col cols="auto">
        <v-btn text small color="primary" @click="showAdditionalFilters = !showAdditionalFilters"
          class="text-capitalize">
          <v-icon small>{{
            showAdditionalFilters ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon>
          {{ showAdditionalFilters ? "Ocultar filtros" : "Mostrar filtros" }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- DEBUG INFO Y CONTROLES TEMPORALES -->
    <!-- <v-row v-if="$vuetify.theme.dark || true" class="mt-4">
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header
              >Debug Info & Controles Temporales</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <div class="mb-4">
                <v-btn @click="debugCurrentState" color="info" class="mr-2"
                  >Debug State</v-btn
                >
                <v-btn @click="forceResetDates" color="warning" class="mr-2"
                  >Reset Fechas</v-btn
                >
                <v-btn @click="checkPersistence" color="error" class="mr-2"
                  >Check Persistence</v-btn
                >
              </div>

              <div class="debug-info">
                <h4>Estado Actual:</h4>
                <p>
                  <strong>Display Fechas:</strong> {{ dateFormatDMY }} -
                  {{ date2FormatDMY }}
                </p>
                <p>
                  <strong>Store Fechas:</strong> {{ $store.state.app.date }} -
                  {{ $store.state.app.date2 }}
                </p>
                <p><strong>Rango:</strong> {{ rangeSelected }}</p>

                <h4>Store Completo:</h4>
                <pre>{{ JSON.stringify($store.getters.debugState, null, 2) }}</pre>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row> -->
  </v-card>
</template>

<script>
import moment from "moment";

export default {
  name: "FilterComponent",

  data() {
    return {
      showAdditionalFilters: false,
      menu: false,
      menu2: false,
      selectedCategoryDgii: "",
      categoryDgii: [],
      dialog: false,
      payments: [],
      accounts: [],
      items: [],
      itemsBussines: [],
      bussinessAccount: [],
      itemsLocations: [],
      itemsLocations2: [],
      itemsDepartment: [],
      categories: [],
      itemSaved: [],
      type_accounts: [],
      rangeTime: [
        { text: "Hoy", value: "1" },
        //  { text: "Ayer", value: "2" },
        { text: "Esta semana", value: "3" },
        { text: "Este mes", value: "4" },
        { text: "Ultimos 3 meses", value: "5" },
        { text: "Este año", value: "6" },
        { text: "Personalizado", value: "7" },
      ],
      loading: false,
      isInitialized: false,
      // Control para evitar emisiones duplicadas
      updateDataTimeout: null,
      isUpdatingData: false,
      // Filtros locales para mejor control
      filters: {
        account: null,
        accountBank: null,
        payments_id: null,
        category: null,
        sub_category: null,
        type_account: null,
      },
    };
  },

  props: {
    show_department: {
      type: Boolean,
      default: true,
    },
    show_location: {
      type: Boolean,
      default: true,
    },
    show_weeks: {
      type: Boolean,
      default: true,
    },
    show_accounts: {
      type: Boolean,
      default: false,
    },
    show_payments: {
      type: Boolean,
      default: false,
    },
    show_accounting: {
      type: Boolean,
      default: false,
    },
    show_refresh: {
      type: Boolean,
      default: true,
    },
    selected_week: {
      type: Number,
      default: 4,
    },
    show_category: {
      type: Boolean,
      default: false,
    },
    show_diary_book_type: {
      type: Boolean,
      default: false,
    },
    showAdditionalFilter: {
      type: Boolean,
      default: false,
    },
    allowed_payment_types: {
      type: Array,
      default: () => [],
    },
    default_payment_type: {
      type: Number,
      default: null,
    },
    // Cuando es true, la unidad de negocio y la cuenta de banco son obligatorias:
    // se oculta la opción "Todas" y se muestran reglas de validación.
    require_selection: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    businessRules() {
      if (!this.require_selection) return [];
      return [(v) => (v !== null && v !== undefined && v !== 0) || "Requerido"];
    },

    accountBankRules() {
      if (!this.require_selection) return [];
      return [(v) => (v !== null && v !== undefined && v !== 0) || "Requerido"];
    },

    business_selected: {
      get() {
        return this.$store.state.app.filters.business;
      },
      set(value) {
        this.$store.commit("setBusiness", value);
      },
    },

    location_selected: {
      get() {
        return this.$store.state.app.filters.location;
      },
      set(value) {
        if (this.isValidLocationValue(value)) {
          this.$store.commit("setLocation", value);
        }
      },
    },

    department_selected: {
      get() {
        return this.$store.state.app.filters.department_id;
      },
      set(value) {
        this.$store.commit("setDepartment", value);
      },
    },

    rangeSelected: {
      get() {
        return this.$store.state.app.rangeSelected;
      },
      set(value) {
        this.$store.commit("setRangeSelected", value);
      },
    },

    date: {
      get() {
        return this.$store.state.app.date;
      },
      set(value) {
        if (value && moment(value).isValid()) {
          this.$store.commit("setDateStart", value);
        }
      },
    },

    date2: {
      get() {
        return this.$store.state.app.date2;
      },
      set(value) {
        if (value && moment(value).isValid()) {
          this.$store.commit("setDateEnd", value);
        }
      },
    },

    dateFormatDMY() {
      // Forzar sincronización con el valor real del store
      const storeDate = this.$store.state.app.date;
      const currentDate = storeDate || moment().startOf("month").format("YYYY-MM-DD");

      return moment(currentDate).format("DD/MM/YYYY");
    },

    date2FormatDMY() {
      // Forzar sincronización con el valor real del store
      const storeDate2 = this.$store.state.app.date2;
      const currentDate2 = storeDate2 || moment().endOf("month").format("YYYY-MM-DD");

      return moment(currentDate2).format("DD/MM/YYYY");
    },

    hasAdditionalFilters() {
      return (
        this.show_department ||
        this.show_accounts ||
        this.show_payments ||
        this.show_accounting ||
        this.show_category ||
        this.show_diary_book_type
      );
    },

    // Computed para obtener filtros completos del store
    completeFilters() {
      return this.$store.getters.completeFilters;
    },
  },

  methods: {
    // Validación de valores de location
    isValidLocationValue(value) {
      if (value === null || value === undefined) return false;
      if (typeof value === "number" && value === 0) return true;
      if (typeof value === "object" && value.value !== undefined) return true;
      return typeof value === "number" && value > 0;
    },

    // Handlers específicos para cada cambio
    handleBusinessChange() {
      this.updateLocationsForBusiness();
      this.updateAccounBanks();
      // El debounce en updateData se encargará de evitar emisiones duplicadas
      this.updateData();
    },

    handleLocationChange() {
      this.updateData();
    },

    handleRangeChange(selectedRange) {
      this.updateRange(selectedRange);
    },

    // Sincronización inicial con el store
    syncWithStore() {
      // Verificar si hay fechas persistidas que no corresponden
      const storeDate = this.$store.state.app.date;
      const storeDate2 = this.$store.state.app.date2;
      const storeFilters = this.$store.state.app.filters;

      // Si las fechas del store no coinciden con el mes actual y no hay una razón válida
      const currentMonth = moment().format("YYYY-MM");
      const storeMonth = storeDate ? moment(storeDate).format("YYYY-MM") : null;

      // Si el rango seleccionado es "Este mes" pero las fechas no corresponden al mes actual
      if (
        this.$store.state.app.rangeSelected === "4" &&
        storeMonth &&
        storeMonth !== currentMonth
      ) {
        this.$store.dispatch("resetToCurrentMonth");
      } else {
        // Inicializar fechas si es necesario
        this.$store.dispatch("initializeDates");
      }

      this.isInitialized = true;
    },

    updateLocationsForBusiness() {
      if (
        !this.$store.state.auth.locations ||
        this.$store.state.auth.locations.length === 0
      ) {
        setTimeout(() => {
          if (
            this.$store.state.auth.locations &&
            this.$store.state.auth.locations.length > 0
          ) {
            this.updateLocationsForBusiness();
          }
        }, 500);
        return;
      }

      this.itemsLocations2 = [];

      if (this.business_selected && this.business_selected != 0) {
        this.itemsLocations2 = this.updateCombo(
          this.itemsLocations,
          this.itemsLocations2,
          this.business_selected,
          "location"
        );
      } else {
        this.itemsLocations2 = [...this.itemsLocations];
        this.itemsLocations2.unshift({ text: "Todas", value: 0 });
      }

      // Validar selección actual
      this.validateLocationSelection();
      this.updateAccounBanks();
    },

    validateLocationSelection() {
      if (this.location_selected) {
        const selectedValue =
          typeof this.location_selected === "object"
            ? this.location_selected.value
            : this.location_selected;

        const locationExists = this.itemsLocations2.find(
          (loc) => loc.value === selectedValue
        );

        if (!locationExists && selectedValue !== 0) {
        }
      } else if (!this.location_selected && this.itemsLocations2.length > 0) {
        this.location_selected = this.itemsLocations2[0];
      }
    },

    updateRange(item) {
      let dateStart, dateEnd;

      switch (item) {
        case "1": // Hoy
          dateStart = dateEnd = moment().format("YYYY-MM-DD");
          break;
        // case "2": // Ayer
        //   dateStart = dateEnd = moment().subtract(1, "day").format("YYYY-MM-DD");
        //   break;
        case "3": // Esta semana
          dateStart = moment().startOf("week").format("YYYY-MM-DD");
          dateEnd = moment().endOf("week").format("YYYY-MM-DD");
          break;
        case "4": // Este mes
          dateStart = moment().startOf("month").format("YYYY-MM-DD");
          dateEnd = moment().endOf("month").format("YYYY-MM-DD");
          break;
        case "5": // Últimos 3 meses
          dateStart = moment().subtract(3, "months").format("YYYY-MM-DD");
          dateEnd = moment().endOf("month").format("YYYY-MM-DD");
          break;
        case "6": // Este año
          dateStart = moment().startOf("year").format("YYYY-MM-DD");
          dateEnd = moment().endOf("year").format("YYYY-MM-DD");
          break;
        case "7": // Personalizado
          return; // No actualizar fechas automáticamente
        default:
          return;
      }

      if (dateStart && dateEnd) {
        this.$store.commit("setDateRange", {
          dateStart: dateStart,
          dateEnd: dateEnd,
        });

        this.updateData();
      }
    },

    async getBusinessAccount() {
      if (this.business_selected != 0) {
        const filter = `where business_unit_id=${this.business_selected}`;

        try {
          const result = await this.api_Post("humanResource/bussinessAccount", {
            filters: filter,
          });

          if (result.status == 200) {
            this.bussinessAccount = await result.json();
            this.bussinessAccount.forEach((account) => {
              account.text = `${account.account_number} (${account.bank_name})`;
            });
          }
        } catch (error) {
          console.error("Error getting business accounts:", error);
        }
      }
    },

    updateAccounBanks() {
      this.filters.accountBank = null;
      if (this.show_accounts === true) {
        this.getBusinessAccount();
      } else {
        this.bussinessAccount = [];
      }
    },

    async updateData() {
      // Evitar emisiones duplicadas con debounce
      if (this.updateDataTimeout) {
        clearTimeout(this.updateDataTimeout);
      }

      // Evitar múltiples ejecuciones simultáneas
      if (this.isUpdatingData) {
        return;
      }

      this.updateDataTimeout = setTimeout(async () => {
        try {
          this.isUpdatingData = true;

          // Validar business_selected
          if (this.business_selected == null && !this.require_selection) {
            this.business_selected = 0;
          }

          // Validar location_selected
          const hasValidLocationSelected =
            this.location_selected &&
            (typeof this.location_selected === "object"
              ? this.location_selected.value !== undefined
              : this.location_selected !== 0);

          if (!hasValidLocationSelected) {
            this.location_selected = { text: "Todas", value: 0 };
          }

          // Validar department
          if (this.department_selected === null) {
            this.department_selected = 0;
          }

          // CRÍTICO: Usar directamente los valores del store, no los computed
          const actualDateStart = this.$store.state.app.date;
          const actualDateEnd = this.$store.state.app.date2;

          // Preparar filtros completos
          const filtersToEmit = {
            business: this.business_selected,
            businessData: this.business_selected,
            location:
              typeof this.location_selected === "object"
                ? this.location_selected.value
                : this.location_selected,
            department_id: this.department_selected,
            dateStart: actualDateStart, // ← USAR VALOR DIRECTO DEL STORE
            dateEnd: actualDateEnd, // ← USAR VALOR DIRECTO DEL STORE
            rangeSelected: this.rangeSelected,
            // Filtros adicionales
            account: this.filters.account,
            accountBank: this.filters.accountBank,
            payments_id: this.filters.payments_id,
            category: this.filters.category,
            sub_category: this.filters.sub_category,
            type_account: this.filters.type_account,
            // Flags adicionales
            isNewOrder: this.$store.state.app.filters.isNewOrder || false,
            isPackage: this.$store.state.app.filters.isPackage || false,
            isDelivery: this.$store.state.app.filters.isDelivery || false,
          };

          // Actualizar store con filtros completos

          this.$store.commit("setFilters", filtersToEmit);
          // Emitir evento al componente padre
          this.$emit("dataFilters", filtersToEmit);
        } catch (error) {
          console.error("Error in updateData:", error);
        } finally {
          this.isUpdatingData = false;
        }
      }, 300); // Debounce de 300ms para dar tiempo a cambios reactivos
    },

    async getData() {
      try {
        this.loading = true;

        // Obtener datos de unidades de negocio
        this.itemsBussines = [...this.$store.state.auth.bussines_units];

        // Obtener tipos de cuentas
        const typeAccounts = await this.api_Get("accounting/type_accounts");
        const result_types_accounts = await typeAccounts.json();
        this.type_accounts = result_types_accounts;
        this.type_accounts.unshift({ id: null, description: "Todas" });

        // Obtener categorías
        const resultTypeCategories = await this.api_Get(
          "accounting/categories_diary_book"
        );
        this.categories = await resultTypeCategories.json();
        this.categories.unshift({ id: null, name: "Todas", parent_id: null });

        // Obtener cuentas contables
        const resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
        const dataTypeAccounts = await resultTypeAccounts.json();

        this.accounts = dataTypeAccounts.map((item) => ({
          text: `${item.code} - ${item.name}`,
          value: item.id,
          dgii_category_id: item.dgii_category_id,
        }));
        this.accounts.unshift({
          text: "Todas",
          value: 0,
          dgii_category_id: null,
        });
        this.filters.account = 0;

        // Obtener métodos de pago
        const paymentsResponse = await this.api_Get("income/payments_types");
        const allPayments = await paymentsResponse.json();
        this.payments = this.allowed_payment_types.length > 0
          ? allPayments.filter(p => this.allowed_payment_types.includes(p.id))
          : allPayments;

        if (this.default_payment_type !== null) {
          this.filters.payments_id = this.default_payment_type;
        }

        // Configurar unidades de negocio ("Todas" no aplica cuando la selección es obligatoria)
        if (!this.require_selection) {
          this.itemsBussines.unshift({ text: "Todas", value: 0 });
        }

        // Configurar rango inicial
        // Configurar rango inicial - solo aplicar el default del prop cuando aún no se ha inicializado el store
        const defaultWeek = this.rangeTime.find(
          (element) => element.value == this.selected_week
        );
        if (!this.$store.state.app._isInitialized && defaultWeek) {
          this.$store.commit("setRangeSelected", defaultWeek.value);
          this.updateRange(defaultWeek.value);
        }

        // Configurar business inicial
        // Con require_selection tampoco es válido el valor 0 ("Todas"), así que se
        // reemplaza por la primera unidad disponible.
        const needsBusiness =
          this.business_selected == null ||
          (this.require_selection && this.business_selected === 0);

        if (needsBusiness && this.$store.state.auth.bussines_units.length > 0) {
          this.$store.commit(
            "setBusiness",
            this.$store.state.auth.bussines_units[0].value
          );
        }

        // Configurar locations y departamentos
        this.itemsLocations = [...(this.$store.state.auth.locations || [])];
        this.itemsDepartment = await this.g_departments();
        this.itemsDepartment.unshift({ text: "Todos", value: 0 });

        // Inicializar locations
        this.updateLocationsForBusiness();

        // Sincronizar con store
        this.syncWithStore();

        // Actualizar datos iniciales
        this.updateData();
      } catch (error) {
        console.error("Error in getData:", error);
      } finally {
        this.loading = false;
      }
    },

    updateCombo(itemsOrigen, itemsDestino, condicion, combo) {
      if (!itemsOrigen || !Array.isArray(itemsOrigen) || itemsOrigen.length === 0) {
        itemsDestino.splice(0, itemsDestino.length);
        itemsDestino.unshift({ text: "Todas", value: 0 });
        return itemsDestino;
      }

      itemsDestino.splice(0, itemsDestino.length);

      for (let item of itemsOrigen) {
        if (item.bus_id === condicion) {
          itemsDestino.push({
            value: item.value,
            text: item.text,
            routes: item.routes,
          });
        }
      }
      itemsDestino.unshift({ text: "Todas", value: 0 });

      // Validar selección actual
      const hasValidSelection =
        this.location_selected &&
        (typeof this.location_selected === "object" ||
          (typeof this.location_selected === "number" && this.location_selected !== 0));

      if (!hasValidSelection) {
        this.location_selected = itemsDestino[0];
      } else {
        const currentSelectionExists = itemsDestino.find((item) => {
          if (typeof this.location_selected === "object") {
            return item.value === this.location_selected.value;
          } else {
            return item.value === this.location_selected;
          }
        });

        if (!currentSelectionExists && this.location_selected.value !== 0) {
        }
      }

      return itemsDestino;
    },

    // Método auxiliar para obtener departamentos
    async g_departments() {
      try {
        const response = await this.api_Get("humanResource/departments");
        return await response.json();
      } catch (error) {
        console.error("Error getting departments:", error);
        return [];
      }
    },

    // Método para obtener iconos de pagos
    getIconPayments(paymentId) {
      const iconMap = {
        1: "mdi-cash",
        2: "mdi-credit-card",
        3: "mdi-bank-transfer",
        4: "mdi-cellphone",
        // Agregar más según sea necesario
      };
      return iconMap[paymentId] || "mdi-cash";
    },

    // Método de utilidad para formatear fechas
    getDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss A");
    },

    // Método para debug (remover en producción)
    debugCurrentState() { },

    // MÉTODO TEMPORAL PARA FORZAR RESET DE FECHAS
    forceResetDates() {
      this.$store.dispatch("resetToCurrentMonth");
      this.$nextTick(() => {
        this.updateData();
      });
    },

    // MÉTODO PARA VERIFICAR PERSISTENCIA
    checkPersistence() {
      const localStorageKeys = Object.keys(localStorage);
      const sessionStorageKeys = Object.keys(sessionStorage);

      // Buscar cualquier clave que contenga 'date', 'filter', etc.
      const suspiciousKeys = [...localStorageKeys, ...sessionStorageKeys].filter(
        (key) =>
          key.toLowerCase().includes("date") ||
          key.toLowerCase().includes("filter") ||
          key.toLowerCase().includes("vuex") ||
          key.toLowerCase().includes("store")
      );

      suspiciousKeys.forEach((key) => {
        const localValue = localStorage.getItem(key);
        const sessionValue = sessionStorage.getItem(key);
      });
    },
  },

  beforeDestroy() {
    // Limpiar timeout para evitar memory leaks
    if (this.updateDataTimeout) {
      clearTimeout(this.updateDataTimeout);
    }
  },

  watch: {
    date(newVal, oldVal) {
      if (newVal !== oldVal && moment(newVal).isValid()) {
        if (this.rangeSelected == "7") {
          this.updateData();
        }
      }
    },

    date2(newVal, oldVal) {
      if (newVal !== oldVal && moment(newVal).isValid()) {
        if (this.rangeSelected == "7") {
          this.updateData();
        }
      }
    },

    rangeSelected(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal != "7") {
          this.updateRange(newVal);
        }
      }
    },

    business_selected(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateLocationsForBusiness();
      }
    },

    "$store.state.auth.locations": {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.updateLocationsForBusiness();
        }
      },
      immediate: true,
    },

    // Watch para debug del estado del store
    "$store.state.app": {
      handler(newVal) {
        if (this.isInitialized) {
        }
      },
      deep: true,
    },
  },

  async created() {
    await this.getData();
  },

  mounted() {
    if (this.showAdditionalFilter) {
      this.showAdditionalFilters = true;
    }
    if (this.$store.state.auth.locations && this.$store.state.auth.locations.length > 0) {
      this.updateLocationsForBusiness();
    }

    // Debug inicial (remover en producción)
    this.$nextTick(() => {
      //  this.debugCurrentState();
    });
  },

  beforeDestroy() { },
};
</script>

<style scoped>
/* Card principal */
.search-header-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

/* Inputs de filtros */
.filter-input {
  transition: all 0.2s ease;
  width: 100%;
  max-width: 100%;
}

.filter-input>>>.v-input__control {
  min-height: 40px;
}

.filter-input>>>.v-input__slot {
  min-height: 40px !important;
  transition: all 0.2s ease;
}

.filter-input:hover>>>.v-input__slot {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.filter-input>>>.v-input__prepend-inner {
  margin-top: 8px;
  margin-right: 8px;
}

/* Botón actualizar */
.update-btn {
  text-transform: none;
  letter-spacing: 0.5px;
  min-width: 140px;
  max-width: 180px;
  height: 40px !important;
  transition: all 0.2s ease;
}

.update-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
}

/* Divider */
.v-divider {
  opacity: 0.5;
}

/* Iconos */
.v-icon {
  transition: all 0.2s ease;
}

.v-input--is-focused .v-icon {
  transform: scale(1.05);
}

/* Row de fechas personalizadas */
.date-range-row {
  width: 100%;
}

/* Responsive - Mobile First */
@media (max-width: 599px) {
  .search-header-card {
    padding: 12px !important;
  }

  .filter-input {
    width: 100%;
  }

  .update-btn {
    width: 100%;
    min-width: 100%;
  }

  .v-col.py-1 {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
}

/* Tablet */
@media (min-width: 600px) and (max-width: 959px) {
  .search-header-card {
    padding: 16px !important;
  }
}

/* Desktop and larger */
@media (min-width: 960px) {
  .filter-input {
    min-width: 220px;
    max-width: 320px;
    flex: 1 1 auto;
  }
}

/* Large Desktop */
@media (min-width: 1264px) {
  .filter-input {
    min-width: 280px;
    max-width: 350px;
  }
}

/* Extra Large Desktop */
@media (min-width: 1904px) {
  .filter-input {
    min-width: 300px;
    max-width: 400px;
  }
}

/* Ajustes para inputs */
.v-input {
  font-size: 14px;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-autocomplete.v-autocomplete--enclosed .v-autocomplete__selections {
  margin-bottom: 0;
}

/* Mejoras para el label */
.filter-input>>>.v-label {
  font-size: 13px;
}

.filter-input>>>.v-label--active {
  font-size: 12px;
}

/* Mejoras para los items del autocomplete */
.filter-input>>>.v-select__selections {
  padding-top: 0;
  padding-bottom: 0;
}

.filter-input>>>.v-select__selection {
  font-size: 14px;
}

/* Estilos para debug panel */
.v-expansion-panel-content pre {
  background: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 12px;
}

.debug-info {
  font-family: "Courier New", monospace;
  font-size: 12px;
}

.debug-info h4 {
  color: #1976d2;
  margin-top: 16px;
  margin-bottom: 8px;
}

.debug-info p {
  margin-bottom: 4px;
}
</style>
